import { useSnackbar } from 'notistack';
import useOn from './socketLib/UseOn';
import { useCallback, useEffect, useRef, useState } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// компонент для отображения событий, которые приходят с сервера
// используется для отображения уведомлений, которые приходят с сервера
export default function Events({ children }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [uploads, setUploads] = useState({});
  useOn('event', (data)=>{
    if (data?.message) {
      if (!uploads[data.id]){
      const key = enqueueSnackbar(data.message, {
        variant: data.type, //"success", "error", "warning", "info"
        // persist: true,
        action: (key) => (
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{ p: 0.5 }}
            onClick={() => closeSnackbar(key)}
          >
            <CloseIcon />
          </IconButton>
        ),
      });
      setUploads((prevUploads) => ({
        ...prevUploads,
        [data.id]: { status: 'in-progress', key: key },
      }));
    }else{
      closeSnackbar(uploads[data.id].key);
      const up = uploads
      delete up[data.id];
      setUploads(up);
      enqueueSnackbar(data.message, {
        variant: data.type, //"success", "error", "warning", "info"
        // persist: true,
        action: (key) => (
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{ p: 0.5 }}
            onClick={() => closeSnackbar(key)}
          >
            <CloseIcon />
          </IconButton>
        ),
      });
    }
      
    }
  });

  return (
    <>{children}</>
  )
}


// Кастомный хук для управления уведомлениями
export function useLocalNotifications() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const enqueueRef = useRef(enqueueSnackbar);
  const closeRef = useRef(closeSnackbar);
  const notificationsRef = useRef({});

  useEffect(() => {
    enqueueRef.current = enqueueSnackbar;
    closeRef.current = closeSnackbar;
  }, [enqueueSnackbar, closeSnackbar]);

  const showNotification = useCallback((data) => {
    if (!data?.message) return;

    const existing = notificationsRef.current[data.id];
    if (existing) {
      closeRef.current(existing.key);
    }

    const key = enqueueRef.current(data.message, {
      variant: data.type || 'info',
      autoHideDuration: 5000,
      action: (key) => (
        <IconButton
          aria-label="close"
          color="inherit"
          sx={{ p: 0.5 }}
          onClick={() => closeRef.current(key)}
        >
          <CloseIcon />
        </IconButton>
      ),
    });

    notificationsRef.current[data.id] = { key };
  }, []);

  return { showNotification };
}